import api from "../lib/api";

// ---- Xero service (placeholder wrappers — swap internals for live Xero API) ----
export async function fetchXeroInvoices() {
  const { data } = await api.post("/invoices/refresh-xero");
  return data;
}
export async function getAwaitingInvoices() {
  const { data } = await api.get("/invoices");
  return data;
}

// ---- Netcash service ----
export async function postNetcashBatch(batchId) {
  const { data } = await api.post(`/batches/${batchId}/send-netcash`);
  return data;
}

// ---- Batches ----
export async function getBatches() {
  const { data } = await api.get("/batches");
  return data;
}
export async function getBatch(id) {
  const { data } = await api.get(`/batches/${id}`);
  return data;
}
export async function createBatch(payload) {
  const { data } = await api.post("/batches", payload);
  return data;
}
export async function addInvoicesToBatch(id, invoiceIds) {
  const { data } = await api.post(`/batches/${id}/add-invoices`, { invoice_ids: invoiceIds });
  return data;
}
export async function removeInvoiceFromBatch(batchId, invoiceId) {
  const { data } = await api.post(`/batches/${batchId}/remove-invoice/${invoiceId}`);
  return data;
}
export async function setBatchProcessingDate(id, processingDate) {
  const { data } = await api.put(`/batches/${id}/processing-date`, { processing_date: processingDate });
  return data;
}
export async function deleteBatch(id) {
  const { data } = await api.delete(`/batches/${id}`);
  return data;
}

// ---- Receipts / Bounced / Logs / Stats ----
export async function getReceipts() {
  const { data } = await api.get("/receipts");
  return data;
}
export async function getBounced() {
  const { data } = await api.get("/bounced");
  return data;
}
export async function getLogs() {
  const { data } = await api.get("/logs");
  return data;
}
export async function getStats() {
  const { data } = await api.get("/stats");
  return data;
}

// ---- Settings ----
export async function getSettings(key) {
  const { data } = await api.get(`/settings/${key}`);
  return data;
}
export async function updateSettings(key, data) {
  const { data: res } = await api.put(`/settings/${key}`, { data });
  return res;
}

// ---- Users (admin) ----
export async function getUsers() {
  const { data } = await api.get("/users");
  return data;
}
export async function createUser(payload) {
  const { data } = await api.post("/users", payload);
  return data;
}
export async function updateUser(id, payload) {
  const { data } = await api.put(`/users/${id}`, payload);
  return data;
}
export async function deleteUser(id) {
  const { data } = await api.delete(`/users/${id}`);
  return data;
}
